import React, { useState, useEffect, useCallback } from "react";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircle";
import guid from "../../../../helpers/guid.helper";
import PassengerListItem from "../../components/Passenger Details/Passenger Detail Form/PassengerListItem";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { borderRadius } from "@mui/system";
import { Card } from "@mui/material";
import "./PassengerList.css";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    backgroundColor: "var(--white)",
    flexGrow: "1",
    [theme.breakpoints.down("sm")]: {
      padding: "2%",
    },
  },
  main: {
    paddingTop: "10%",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "32%",
    },
  },
}));

function PassengerList(props) {
  const classes = useStyles();
  const defaultData = {
    id: guid(),
    birthday: null,
    category: "adult",
    email: "",
    name: "",
    surname: "",
    nationality: "in",
    phone: "",
    title: "mr",
    cardno: "",
    expiration: null,
  };
  const { passengers } = props;
  const { dispatch } = props;

  const setPassengers = (data) => {
    dispatch({ type: "SET_PASSENGERS", data });
  };
  const addPassenger = () => {
    let _passengers = [...passengers];
    setPassengers([..._passengers, { ...defaultData, id: guid() }]);
  };

  useEffect(() => {
    let _passengers = [];
    if (props.adults && props.adults > 0) {
      for (let i = 0; i < props.adults; i++) {
        _passengers.push({ ...defaultData, id: guid(), category: "adult" });
      }
    }
    if (props.childs && props.childs > 0) {
      for (let i = 0; i < props.childs; i++) {
        _passengers.push({ ...defaultData, id: guid(), category: "child" });
      }
    }
    if (props.infants && props.infants > 0) {
      for (let i = 0; i < props.infants; i++) {
        _passengers.push({ ...defaultData, id: guid(), category: "infant" });
      }
    }
    setPassengers(_passengers);
  }, [props.adults, props.childs, props.infants]);
  return (
    <Card className="main-pass-container">
      <Grid
        container
        style={{ marginBottom: "1.25rem" }}
        className="passangerContainer"
      >
        <Grid item xs="12" md="6">
          <Typography variant="h6" className="passengerHeading">
            {props.label ? props.label : "Passengers Details"}
          </Typography>
        </Grid>
      </Grid>
      <Paper className={classes.control} elevation={0}>
        <Grid container style={{ gap: "1rem" }}>
          {/* Group passengers by category */}
          {passengers.some((p) => p.category === "adult") && (
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 600,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                }}
              >
                Adult Passengers (12+ years)
              </Typography>
              {passengers
                .filter((p) => p.category === "adult")
                .map((passenger, i) => (
                  <PassengerListItem
                    document_options={props.document_options}
                    selectedCurrency={props.selectedCurrency}
                    canRemove={i > 0}
                    key={passenger.id}
                    data={passenger}
                    country_code={props.country_code}
                    type={props.type}
                  />
                ))}
            </Grid>
          )}

          {passengers.some((p) => p.category === "child") && (
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 600,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                }}
              >
                Child Passengers (2-11 years)
              </Typography>
              {passengers
                .filter((p) => p.category === "child")
                .map((passenger, i) => (
                  <PassengerListItem
                    document_options={props.document_options}
                    selectedCurrency={props.selectedCurrency}
                    canRemove={false}
                    key={passenger.id}
                    data={passenger}
                    country_code={props.country_code}
                    type={props.type}
                  />
                ))}
            </Grid>
          )}

          {passengers.some((p) => p.category === "infant") && (
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 600,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                }}
              >
                Infant Passengers (under 2 years)
              </Typography>
              {passengers
                .filter((p) => p.category === "infant")
                .map((passenger, i) => (
                  <PassengerListItem
                    document_options={props.document_options}
                    selectedCurrency={props.selectedCurrency}
                    canRemove={false}
                    key={passenger.id}
                    data={passenger}
                    country_code={props.country_code}
                    type={props.type}
                  />
                ))}
            </Grid>
          )}
        </Grid>
      </Paper>
    </Card>
  );
}
const mapStateWithProps = (state) => {
  let country_code = "";
  if (state.user.userDetails && state.user.userDetails.country_code) {
    country_code = state.user.userDetails.country_code;
  } else if (
    state.vendor.vendorDetail &&
    state.vendor.vendorDetail.country_code
  ) {
    country_code = state.vendor.vendorDetail.country_code;
  }
  return {
    passengers: state.flight.passengers,
    country_code: country_code,
  };
};

export default React.memo(connect(mapStateWithProps)(PassengerList));

PassengerList.defaultProps = {
  adults: 1,
  childs: 0,
  infants: 0,
};
